import { BagPersonalOffIcon } from './BagPersonalOffIcon';

/**
 * author: Michael Richins
 * id 9B14800C-E104-4A89-9773-B220CA30A403
 * name bag-personal-off
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-personal-off.svg
 * tags
 * - Transportation + Flying 
 */
export const BackpackOffIcon = BagPersonalOffIcon;
export default BackpackOffIcon